<script lang="ts">
	import SettingsRenderer from 'src/components/Settings/shared/SettingsRenderer.svelte';
	import { homeSettingsConfig } from 'src/configs/settings/HomeSettingsConfig';
</script>

<SettingsRenderer config={homeSettingsConfig.v2} variant="v2" />
